import { styled } from "@mui/material/styles"
import Typography from "@mui/material/Typography"

const NotificationMessage = styled(Typography)(({ theme }) => ({
  fontSize: "1.1rem",
  color: theme.palette.gray["14"],

  "& strong": {
    fontSize: "1.3rem"
  }
}))

export default NotificationMessage
